// const ww = window.innerWidth
// const wh = window.innerHeight

export default {
  s1: {
    s1_rect: [
      {
        delay: 0,
        duration: .8,
        from: { x: 0 },
        onStart: function() {
          setTimeout(() => {
            this.$bus.playMusic('cat')
          }, 200)
        },
      },
      {
        delay: 0,
        duration: .8,
        from: { alpha: 0 }
      }
    ],
    s1_chat1: [
      {
        onStart: function() {
          this.$bus.playMusic('wechat')
        },
        delay: 1,
        duration: .1,
        from: { alpha: 0 }
      }
    ],
    s1_chat2: [
      {
        delay: 1,
        duration: .1,
        from: { alpha: 0 }
      }
    ],
    s1_chat3: [
      {
        delay: 1,
        duration: .1,
        from: { alpha: 0 }
      }
    ],
    s1_text: [
      {
        delay: 1.6,
        duration: 2,
        from: { alpha: 0 },
        to: { alpha: 1 },
        onComplete: function() {
          setTimeout(() => {
            this.sceneComplete()
          }, 500)
        },
      }
    ],
  },
  s2: {
    s2_light: [
      {
        delay: 0,
        duration: 2,
        from: { alpha: 0.2 }
      }
    ],
    s2_rect: [
      {
        delay: 0,
        duration: .8,
        from: { x: 0 }
      },
      {
        delay: 0,
        duration: .8,
        from: { alpha: 0 }
      }
    ],
    s2_chat1: [
      {
        onStart: function() {
          this.$bus.playMusic('wechat')
        },
        delay: 1,
        duration: .1,
        from: { alpha: 0 }
      }
    ],
    s2_chat2: [
      {
        delay: 1,
        duration: .1,
        from: { alpha: 0 }
      }
    ],
    s2_chat3v2: [
      {
        onStart: function() {
          setTimeout(() => {
            this.$bus.loopMusic('clock')
            this.$bus.playMusic('clock')
            setTimeout(() => {
              this.$bus.musicFadeOut('clock')
            }, 3200)
          }, 800)
        },
        delay: 1,
        duration: .1,
        from: { alpha: 0 }
      }
    ],
    s2_text: [
      {
        delay: 1.6,
        duration: 2,
        from: { alpha: 0 },
        to: { alpha: 1 },
        onComplete: function() {
          setTimeout(() => {
            this.sceneComplete()
          }, 500)
        },
      }
    ],
  },
  s3: {
    s3_light: [
      {
        onStart: function() {
          this.$bus.playMusic('car2')
          this.$bus.playMusic('typing2')
        },
        delay: 0,
        duration: 4,
        from: { alpha: 0.2 }
      }
    ],
    s3_hand: [
      {
        delay: 0,
        duration: .5,
        from: { rotation: 0 },
        to: { rotation: 1 / 360 * Math.PI },
        yoyo: true,
        repeat: 3
      },
      {
        delay: 2,
        duration: .5,
        from: { rotation: 0 },
        to: { rotation: 2 / 360 * Math.PI },
        yoyo: true,
        repeat: 1
      },
      {
        delay: 3,
        duration: .5,
        from: { rotation: 0 },
        to: { rotation: 1.5 / 360 * Math.PI },
        yoyo: true,
        repeat: 3
      },
      {
        delay: 5,
        duration: .5,
        from: { rotation: 0 },
        to: { rotation: 3 / 360 * Math.PI },
        yoyo: true,
        repeat: 1,
        onStart: function() {
          this.$bus.musicFadeOut('typing2')
        }
      },
    ],
    s3_chat: [
      {
        onStart: function() {
          this.$bus.playMusic('wechat')
        },
        delay: 1,
        duration: .1,
        from: { alpha: 0 }
      }
    ],
    s3_text: [
      {
        delay: 2,
        duration: 2,
        from: { alpha: 0 },
        to: { alpha: 1 },
        onComplete: function() {
          setTimeout(() => {
            this.sceneComplete()
          }, 500)
        },
      }
    ],
    s3_tag: [
      {
        delay: 0,
        duration: 1,
        from: { rotation: -Math.PI * 10 / 360 },
        to: { rotation: Math.PI * 5 / 360 },
        repeat: -1,
        yoyo: true
      }
    ]
  }
}